export interface ModalButtonConfig {
  label?: string;
  icon: string;
  severity: Severity;
  action?: () => void;
}

export interface ModalConfig {
  display?: boolean;
  headerTitle?: string;
  content?: string;
  link?: boolean;
  linkLabel?: string;
  linkContent?: {
    href?: string,
    text?: string,
    icon?: boolean,
    iconButton?: ModalButtonConfig
  };
  showFooter?: boolean;
  footerButtons?: ModalButtonConfig[];  // Footer buttons are optional
  dialogStyle?: any;
  contentStyle?: any;
  buttonStyle?: any;
  linkLabelStyle?: any;
  linkContentStyle?: any;
  additionnalText?: boolean;
  additionnalTextContent?: string;
  additionnalTextStyle?: any;
}

export enum Severity {
  success = 'success',
  secondary = 'secondary',
  danger = 'danger',
  info = 'info', 
  warning = 'warn'
}